import { getSthpHost } from '../config';
import { getMockedTermsData } from '../utils/getApiMockData';

export const getDocumentLinks = async (env, locale) => {
  const url = new URL(
    `${getSthpHost(env)}/api/v2/user-document-store/splash-screens/create-account?locale=${locale}`
  );

  let documentLinks = {},
    explicitSigningRequired = false;
  try {
    const response = await fetch(url);

    if (response.ok) {
      const json = await response.json();

      documentLinks = json.result[0].documentLinks;
      explicitSigningRequired = json.result[0].explicitSigningRequired;
    } else {
      throw new Error(response.status);
    }
  } catch (error) {
    console.log('Something went wrong when trying to fetch documentlinks from sthp.', error);
  }

  if (!documentLinks && env === 'local') {
    console.log('Fetching local data, rather than depending on API');
    documentLinks = getMockedTermsData();
  }

  return { documentLinks, explicitSigningRequired };
};

export const socialLoginWeb = async (env, fbId, fbToken) => {
  const socialLoginWebUrl = new URL(
    `${getSthpHost(env)}/api/socialLoginWeb.action?socialId=${fbId}&fbToken=${fbToken}`
  );

  const response = await fetch(socialLoginWebUrl);
  return await response.json();
};

export const exchangeIdTokenForSsoToken = async (idToken, env, country, language) => {
  const url = new URL(`${getSthpHost(env)}/${country}/${language}/firebaseWebLoginMod.action`);
  url.searchParams.set('terminal', 'Web2.0');

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token: idToken }),
  });

  return await response.json();
};
